import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FormEventHandler } from 'react';
import { useFormContext } from 'react-hook-form';

import { EmploymentBusinessCategorySelection } from '@/components/Form/Employment/EmploymentBusinessCategorySelection';
import { FormErrorLogger } from '@/components/Form/FormErrorLogger';
import { Select } from '@/components/Form/Select';
import { TextInput } from '@/components/Form/TextInput';

import { EMPLOYER_MAX_LENGTH } from '@/constants/places';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { selectConfigsState } from '@/redux/configs';

import { EmploymentInfoForm } from '../helper';

import { EmployerFormContainer } from '../EmploymentInfo.styled';

interface CaymanSelfEmployedFormProps {
  onSubmit: FormEventHandler<HTMLDivElement>;
}

export const CaymanSelfEmployedForm = ({
  onSubmit,
}: CaymanSelfEmployedFormProps) => {
  const { t } = useTranslate();
  const { occupations } = useAppSelector(selectConfigsState);
  const {
    control,
    formState: { errors: visibleErrors, isValid },
  } = useFormContext<EmploymentInfoForm>();

  return (
    <EmployerFormContainer onSubmit={onSubmit}>
      <Typography variant="h3" textAlign="center">
        {t('selfEmployedForm.title')}
      </Typography>

      <Stack spacing={2} direction={'column'}>
        <TextInput
          name="employmentDetailed.employerName"
          control={control}
          error={!!visibleErrors.employmentDetailed?.employerName}
          helperText={visibleErrors.employmentDetailed?.employerName?.message}
          fullWidth
          label={t('employerForm.form.businessName.label')}
          rules={{
            required: t('employerForm.form.businessName.required'),
            maxLength: {
              value: EMPLOYER_MAX_LENGTH.employerName,
              message: t('employerForm.form.businessName.maxLength', {
                number: EMPLOYER_MAX_LENGTH.employerName,
              }),
            },
          }}
        />
        <EmploymentBusinessCategorySelection<EmploymentInfoForm>
          control={control}
          name="employmentDetailed.businessCategoryCode"
          label={t('employerForm.form.businessCategory.label')}
        />
        <Select
          options={occupations}
          control={control}
          name="employmentDetailed.occupationCode"
          error={!!visibleErrors.employmentDetailed?.occupationCode}
          helperText={visibleErrors.employmentDetailed?.occupationCode?.message}
          rules={{
            required: t('employerForm.form.occupationCode.required'),
          }}
          fullWidth
          placeholder={t('employerForm.form.occupationCode.placeholder')}
          label={t('employerForm.form.occupationCode.label')}
          useDrawerOnMobile
          withSearchBar
        />
      </Stack>

      <Button variant="outlined" type="submit" fullWidth disabled={!isValid}>
        {t('questionDrawer.connection.button.proceed')}
      </Button>

      <FormErrorLogger formName="CaymanSelfEmployedForm" control={control} />
    </EmployerFormContainer>
  );
};
